import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import type { SxProps, Theme } from "@mui/material/styles";

type OkMsgsProps = {
  msgs: (string | undefined)[] | undefined;
  ok: boolean;
  setOk: (value: boolean) => void;
  sx?: SxProps<Theme>;
};

const OkMsgs: React.FC<OkMsgsProps> = (props) => {
  let { msgs } = props;
  const { ok, setOk, sx } = props;

  if (!msgs) return <></>;
  msgs = msgs.filter((item) => item !== undefined);

  return msgs.length > 0 ? (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={ok}
      onClose={() => setOk(false)}
      autoHideDuration={3500}
      sx={sx}
    >
      <Alert severity="success">
        {msgs.map((msg) => (
          <Typography key={msg}>{msg}</Typography>
        ))}
      </Alert>
    </Snackbar>
  ) : (
    <></>
  );
};

export default OkMsgs;
